export default __webpack_public_path__ + "static/media/carlos2.c339a7f8.png";